import React from 'react';
import LegalHero from '../components/LegalHero';

const PrivacyPolicy = () => {
  const effectiveDate = 'January 15, 2026';
  const entityName = 'Nalexus Technologies (Private) Limited';
  const address = '3rd Floor, Nalexus Technologies, 12-L MM Alam Rd, Gulberg, Lahore, Punjab 54600';
  const contactEmail = 'contact@nalexustechnologies.com';
  const infoEmail = 'info@nalexustechnologies.com';
  const careerEmail = 'career@nalexustechnologies.com';
  const businessWhatsApp = '+92 327 7477744';

  const summary = [
    { label: 'Effective date', value: effectiveDate },
    { label: 'Last updated', value: effectiveDate },
    { label: 'Legal entity', value: entityName },
    { label: 'Registered address', value: address },
    { label: 'General inquiries', value: <a href={`mailto:${contactEmail}`}>{contactEmail}</a> },
    { label: 'Info & privacy', value: <a href={`mailto:${infoEmail}`}>{infoEmail}</a> },
    { label: 'Careers', value: <a href={`mailto:${careerEmail}`}>{careerEmail}</a> },
    { label: 'Business WhatsApp', value: <a href="https://wa.me/923277477744" target="_blank" rel="noreferrer">{businessWhatsApp}</a> },
  ];

  const sections = [


    {


      title: '1) Who we are',


      content: (


        <>


          <p>


            Nalexus Technologies is the brand name for {entityName}, an IT services and consultancy practice based in Pakistan.


            We operate from {address} and can be reached at {contactEmail} for general questions or {infoEmail}


            {' '}for privacy-specific inquiries. Pakistan currently does not have an enacted, GDPR-equivalent


            comprehensive data protection law, but there are constitutional privacy protections and sectoral rules, with


            a Personal Data Protection Bill progressing through draft iterations.


          </p>


          <p>
            Background information about the ongoing regulatory work is maintained by the Ministry of Information
            Technology & Telecommunication at{' '}
            <a href="https://moitt.gov.pk/" target="_blank" rel="noreferrer">
              https://moitt.gov.pk/
            </a>.
          </p>


        </>


      ),


    },


    {


      title: '2) Scope',


      content: (


        <>


          <p>This Privacy Policy applies to:</p>


          <ul className="legal-list">


            <li>Our website, microsites, and landing pages that link to this policy.</li>


            <li>Sales conversations, proposals, demos, and other pre-sales communications.</li>


            <li>Newsletter subscriptions, events, webinars, and marketing campaigns managed by Nalexus Technologies.</li>


            <li>Delivery of our professional services where we act as a controller for project collaboration.</li>


          </ul>


          <p>The policy does not govern:</p>


          <ul className="legal-list">


            <li>Client-controlled websites, applications, or platforms.</li>


            <li>Data we process strictly on behalf of a client following a services agreement (see Section 10).</li>


          </ul>


        </>


      ),


    },


    {


      title: '3) Key definitions',


      content: (


        <ul className="legal-list">


          <li>


            <strong>Personal information:</strong> Information that identifies a person directly or indirectly, such as


            name, email, phone, or IP address.


          </li>


          <li>


            <strong>Controller:</strong> The party that decides why and how personal information is processed.


          </li>


          <li>


            <strong>Processor:</strong> The party that processes personal information on a controller's instructions.


          </li>


          <li>


            <strong>Customer Data:</strong> Data provided to Nalexus Technologies by a client, or collected on a client's behalf, while


            delivering services.


          </li>


        </ul>


      ),


    },


    {


      title: '4) Information we collect',


      content: (


        <>


          <h5 className="legal-subheading">4.1 Information you provide</h5>


          <p>We may collect:</p>


          <ul className="legal-list">


            <li>Contact details such as name, email, phone, company, role, and location.</li>


            <li>Inquiry details including project goals, requirements, budgets, timelines, and communications.</li>


            <li>Commercial records (proposals, statements of work, invoicing information, and tax identifiers).</li>


            <li>Support and delivery details, including tickets, technical logs, or environment snapshots you share.</li>


            <li>Recruitment details if you apply for a role (CVs, portfolios, references, or assessment feedback).</li>


          </ul>


          <h5 className="legal-subheading">4.2 Information collected automatically</h5>


          <p>When you use our website we may gather:</p>


          <ul className="legal-list">


            <li>Device and browser details (type, operating system, browser version, and language).</li>


            <li>Usage data (pages viewed, clicks, navigation paths, referring URLs, and time spent).</li>


            <li>Log data (IP address, timestamps, and security or error logs).</li>


            <li>Approximate location inferred from IP address. We do not collect precise GPS data unless you enable it.</li>


          </ul>


          <h5 className="legal-subheading">4.3 Information from third parties</h5>


          <ul className="legal-list">


            <li>Referrals, partners, or venture networks that introduce us to a project.</li>


            <li>Publicly available professional information (for example, business websites or conference bios).</li>


            <li>Vendors providing analytics, CRM, communications, recruiting, or event support.</li>


          </ul>


        </>


      ),


    },


    {


      title: '5) How we use information',


      content: (


        <>


          <h5 className="legal-subheading">5.1 Communication and relationship management</h5>


          <ul className="legal-list">


            <li>Respond to inquiries, schedule consultations, and coordinate discovery workshops.</li>


            <li>Prepare proposals, commercial models, and scope documents.</li>


            <li>Maintain account history for clients and prospective clients.</li>


          </ul>


          <h5 className="legal-subheading">5.2 Service delivery and operations</h5>


          <ul className="legal-list">


            <li>Deliver software engineering, SaaS product engineering, CMS, automation, AI, and GenAI solutions.</li>


            <li>Manage access to documentation, project backlogs, quality environments, and collaboration tools.</li>


            <li>Handle testing, troubleshooting, monitoring, and release coordination in agreed environments.</li>


          </ul>


          <h5 className="legal-subheading">5.3 Website and business improvement</h5>


          <ul className="legal-list">


            <li>Analyse which pages or resources are most helpful.</li>


            <li>Improve navigation, layout, and content relevance.</li>


          </ul>


          <h5 className="legal-subheading">5.4 Security and fraud prevention</h5>


          <ul className="legal-list">


            <li>Protect our systems, prevent abuse, and investigate suspicious or malicious activity.</li>


            <li>Maintain audit trails for platform access and security events.</li>


          </ul>


          <h5 className="legal-subheading">5.5 Legal and compliance</h5>


          <ul className="legal-list">


            <li>Comply with applicable laws and lawful requests.</li>


            <li>Maintain records for audit, tax, and contractual obligations.</li>


          </ul>


        </>


      ),


    },


    {


      title: '6) Legal basis and processing approach',


      content: (


        <>


          <p>


            Because Nalexus Technologies is primarily established in Pakistan, we typically rely on contractual necessity, legitimate


            business interests, or consent where required. Pakistan recognises privacy as a constitutional principle, and


            cyber and electronic transaction laws govern digital records and conduct.


          </p>


          <p>
            Reference materials regarding the jurisdiction's privacy and cyber frameworks are published on the
            {' '}
            <a href="https://www.pakistancode.gov.pk/" target="_blank" rel="noreferrer">
              Pakistan Code (pakistancode.gov.pk)
            </a>
            {' '}portal.
          </p>


          <p>


            If a project involves individuals in jurisdictions with heightened requirements (for example, EU/UK or state


            privacy laws), we will align with the applicable legal basis, enter into the right contractual terms, and


            support cross-border requirements.


          </p>


        </>


      ),


    },


    {


      title: '7) Cookies and similar technologies',


      content: (


        <>


          <p>We may use cookies or similar technologies for:</p>


          <ul className="legal-list">


            <li>Essential functions such as load balancing, authentication, and security.</li>


            <li>Preferences that remember your settings.</li>


            <li>Analytics that help us understand usage and improve the experience.</li>


            <li>Marketing measurement where campaigns are enabled.</li>


          </ul>


          <p>You can control cookies through browser settings or any consent banner we provide. Disabling certain cookies may limit site functionality.</p>


        </>


      ),


    },


    {


      title: '8) How we share information',


      content: (


        <>


          <p>We do not sell personal information. We may share information with:</p>


          <h5 className="legal-subheading">8.1 Service providers</h5>


          <p>Vendors that support hosting, communications, analytics, monitoring, CRM, support tooling, or payment processing. They may only process data on our instructions and must maintain safeguards.</p>


          <h5 className="legal-subheading">8.2 Professional advisers</h5>


          <p>Lawyers, accountants, auditors, bankers, and insurers assisting our operations.</p>


          <h5 className="legal-subheading">8.3 Legal disclosures</h5>


          <p>


            We may disclose information where required by law, court order, or lawful request. Pakistan's cybercrime rules are set out in PECA 2016 and subsequent amendments, which are published on the


            {' '}<a href="https://www.pakistancode.gov.pk/" target="_blank" rel="noreferrer">Pakistan Code</a> portal.


          </p>


          <h5 className="legal-subheading">8.4 Business transfers</h5>


          <p>If we are involved in a merger, acquisition, investment, or sale, data may be transferred with the business, subject to appropriate safeguards.</p>


        </>


      ),


    },


    {


      title: '9) International data transfers',


      content: (


        <>


          <p>


            We may process or store information outside Pakistan depending on where our vendors host data, where clients ask systems to reside, or where collaboration teams operate.


          </p>


          <p>


            When information crosses borders, we use reasonable safeguards such as contractual commitments, controlled access, encryption in transit, and least-privilege account design.


          </p>


        </>


      ),


    },


    {


      title: '10) Customer Data and processor role',


      content: (


        <>


          <p>When we provide services to a client, we may process Customer Data under that client's instructions.</p>


          <ul className="legal-list">


            <li>The client is usually the controller.</li>


            <li>Nalexus Technologies is usually the processor.</li>


            <li>Our handling is governed by the relevant agreement and any data processing addendum.</li>


          </ul>


          <p>If you are an end user whose data is controlled by our client, contact that client directly for rights requests. We support clients with reasonable assistance per contract.</p>


        </>


      ),


    },


    {


      title: '11) AI systems and Generative AI',


      content: (


        <>


          <p>Projects may include AI or GenAI capabilities. Depending on the solution:</p>


          <h5 className="legal-subheading">Inputs and outputs</h5>


          <ul className="legal-list">


            <li>Inputs may include prompts, tickets, documents, or knowledge base assets supplied by authorized users.</li>


            <li>Outputs may include summaries, classifications, extracted fields, suggestions, or generated content.</li>


          </ul>


          <h5 className="legal-subheading">Model hosting and providers</h5>


          <p>Solutions may use client-hosted, Nalexus-hosted, or third-party models when those providers are expressly approved.</p>


          <h5 className="legal-subheading">Training and reuse</h5>


          <p>Unless expressly agreed, we do not use Customer Data to train public models, do not publish Customer Data, and restrict access to authorized team members.</p>


          <h5 className="legal-subheading">Safety controls</h5>


          <p>Where GenAI is involved we apply role-based access control, logging, monitoring, guardrails such as retrieval grounding or content filtering, and human review where appropriate.</p>


        </>


      ),


    },


    {


      title: '12) Data retention',


      content: (


        <>


          <p>We retain personal information only as long as necessary for the purposes in this policy, contractual requirements, or legal/audit obligations.</p>


          <ul className="legal-list">


            <li>Sales inquiries are retained for a reasonable period for follow-up and pipeline analysis.</li>


            <li>Client communications and project records remain available for contract performance, knowledge transfer, and compliance.</li>


            <li>Security logs are retained for monitoring, investigations, and threat hunting.</li>


          </ul>


          <p>Where feasible we delete, anonymize, or de-identify data once it is no longer needed.</p>


        </>


      ),


    },


    {


      title: '13) Security',


      content: (


        <>


          <p>We use reasonable technical and organizational measures to protect personal information, including:</p>


          <ul className="legal-list">


            <li>Access control, least privilege, and MFA where available.</li>


            <li>Encryption in transit and at rest for key environments.</li>


            <li>Secure development practices, code reviews, and dependency management.</li>


            <li>Monitoring and alerting for anomalous activity.</li>


            <li>Vendor due diligence for critical systems.</li>


          </ul>


          <p>No system is entirely secure. If you suspect an issue, contact us at {infoEmail}.</p>


        </>


      ),


    },


    {


      title: '14) Your choices and rights',


      content: (


        <>


          <p>Depending on your jurisdiction and relationship with Nalexus Technologies you may request:</p>


          <ul className="legal-list">


            <li>Access to the personal information we hold about you.</li>


            <li>Correction of inaccurate information.</li>


            <li>Deletion of data, where legally and contractually permitted.</li>


            <li>Withdrawal of consent for marketing communications.</li>


          </ul>


          <p>Submit requests to {infoEmail}. We may require verification before responding.</p>


        </>


      ),


    },


    {


      title: '15) Marketing communications',


      content: (


        <>


          <p>You can opt out of marketing emails at any time by using the unsubscribe link in those emails or contacting us at {infoEmail}. We may still send operational or service emails related to active engagements.</p>


        </>


      ),


    },


    {


      title: "16) Children's privacy",


      content: (


        <p>Our website and services are not directed to children under 13, and we do not knowingly collect personal information from children under 13.</p>


      ),


    },


    {


      title: '17) Third-party links',


      content: (


        <p>Our website may contain links to third-party services. Their privacy practices are governed by their own policies, and we are not responsible for their content or processing.</p>


      ),


    },


    {


      title: '18) Updates to this policy',


      content: (


        <p>We may update this policy periodically. The updated version will be posted on this page with a revised "Last updated date.</p>


      ),


    },


    {


      title: '19) Contact',


      content: (


        <>


          <p>For privacy questions or requests, contact us:</p>


          <ul className="legal-list">


            <li>Email: <a href={`mailto:${infoEmail}`}>{infoEmail}</a></li>


            <li>Address: {address}</li>


          </ul>


        </>


      ),


    },


  ];





  return (


    <>


      <LegalHero


        eyebrow="Policy"


        title="Privacy Policy"


        description="How Nalexus Technologies collects, uses, and safeguards personal information across our website and consulting engagements."


      />





      <section className="legal-summary sec-mar-top">


        <div className="container">


          <div className="row g-4">


            {summary.map((item) => (


              <div className="col-lg-4 col-sm-6" key={item.label}>


                <div className="legal-card legal-card--summary">


                  <p className="legal-card__label">{item.label}</p>


                  <p className="legal-card__value">{item.value}</p>


                </div>


              </div>


            ))}


          </div>


        </div>


      </section>





      <section className="legal-body sec-mar">


        <div className="container">


          <div className="legal-body__grid">


            {sections.map((section) => (


              <article className="legal-card" key={section.title}>


                <h4>{section.title}</h4>


                {section.content}


              </article>


            ))}


          </div>


        </div>


      </section>


    </>


  );


};





export default PrivacyPolicy;



